var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4192",
    "data-name": "Group 4192",
    transform: "translate(-940 -291)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(940 291)",
    fill: "#41a6e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13738",
    "data-name": "Path 13738",
    d: "M103.042,104l-12.7,12.118L84,110.059",
    transform: "translate(867.252 202.427)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTCheckmark);
export default __webpack_public_path__ + "static/media/TCheckmark.3368b2868b42048cea2abc8faa74239e.svg";
export { ForwardRef as ReactComponent };